import React, { useState, useEffect } from "react";
import {
  Typography,
  Grid,
  Card,
  TextField,
  Box,
  Button,
} from "@mui/material";
import { FormControl, InputLabel, Select, MenuItem } from "@mui/material";
import { AddCircle, East, West } from "@mui/icons-material";
import DeleteIcon from "@mui/icons-material/Delete";

const TransportSection = ({
  harvest,
  handleNext,
  handleBack,
  emissionFactors,
  totalTransportEmission,
  setTotalTransportEmission,
}) => {
  const [transportType, setTransportType] = useState("");
  const [transportElectricity, setTransportElectricity] = useState(0);
  const [entries, setEntries] = useState(totalTransportEmission);
  const [mode, setMode] = useState("");
  const [load, setLoad] = useState(0);
  const [distance, setDistance] = useState(null);
  const [totalEmission, setTotalEmission] = useState(0);

  useEffect(() => {
    const calculatedTotalEmission = entries
      .map((entry) => entry.emission)
      .reduce((acc, current) => acc + current, 0);
    setTotalEmission(calculatedTotalEmission);
  }, [entries]);

  const handleAddEntry = () => {
    if (mode && distance && load) {
      const newEntry = {
        mode,
        distance: parseFloat(distance),
        load: parseFloat(load),
        emission: calculateEmission(mode, distance, transportElectricity),
        electricity: parseFloat(transportElectricity),
      };

      setEntries([...entries, newEntry]);
      setTotalTransportEmission([...totalTransportEmission, newEntry]);
      // setTotalEmission(totalEmission + newEntry.emission);

      // Reset input fields after adding an entry
      setMode("");
      setDistance(0);
      setLoad(0);
      setTransportType("");
      setTransportElectricity(0);
    }
  };

  const handleDeleteEntry = (index) => {
    // setTotalEmission(totalEmission - deletedEntry.emission);
    // setTotalTransportEmission(totalEmission)

    const updatedEntries = entries.filter((entry, i) => i !== index);
    setEntries(updatedEntries);
    setTotalTransportEmission(updatedEntries);
  };

  const calculateEmission = (mode, distance, electricity) => {
    const vehicles = parseFloat(harvest) / parseFloat(load);
    console.log("Vehicles:", vehicles);

    const emissionFactor = emissionFactors.Transport.Mode;

    return emissionFactor[mode] * distance * vehicles + electricity * 0.874;
  };

  console.log("Total Transport", totalTransportEmission);

  return (
    <>
      <Grid
        container
        fullWidth
        justifyContent="center"
        mx="auto"
        mb={4}
        mt="10%"
        borderRadius={4}
        p={2}
        xs={12}
        style={{
          boxShadow: "rgba(0, 0, 0, 0.15) 0px 5px 15px 0px",
          background:
            "linear-gradient(to right bottom, #ffffff, #fdfdfe, #fafbfd, #f7f9fb, #f3f7fa",
        }}
      >
        <Grid item xs={12} flex>
          <Typography ml={2} mb={2} variant="h4">
            Transportation
          </Typography>
        </Grid>

        <Card
          elevation={2}
          boxShadow={2}
          sx={{ px: 2, py: 2, borderRadius: 6 }}
        >
          <Grid container xs={12} flex fullWidth>
            <Grid item xs={12} md={6} py={2} px={4}>
              <Typography variant="h6">Select type</Typography>
              <Box mt={2}>
                <FormControl fullWidth>
                  <InputLabel id="demo-simple-select-label">
                    Transporation type
                  </InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    value={transportType}
                    label="Transporation type"
                    onChange={(e) => {
                      setTransportType(e.target.value);
                    }}
                  >
                    <MenuItem value={"Cold"}>Cold transportation</MenuItem>
                    <MenuItem value={"Traditional"}>
                      Traditional transporation
                    </MenuItem>
                  </Select>
                </FormControl>
              </Box>
            </Grid>
            <Grid item xs={12} md={6} py={2} px={4}>
              <Typography variant="h6">
                Electricity used while transporation
              </Typography>
              <Box mt={2}>
                <FormControl fullWidth>
                  <TextField
                    label="in kWh"
                    variant="outlined"
                    value={transportElectricity}
                    onChange={(event) => {
                      setTransportElectricity(event.target.value);
                    }}
                  />
                </FormControl>
              </Box>
            </Grid>
            <Grid item xs={12} md={4} py={2} px={4}>
              <Typography variant="h6">Select mode</Typography>
              <Box mt={2}>
                <FormControl fullWidth>
                  <InputLabel id="demo-simple-select-label">
                    Transporation by
                  </InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    value={mode}
                    label="Transporation by"
                    onChange={(e) => {
                      setMode(e.target.value);
                    }}
                  >
                    <MenuItem value={"Air"}>Air</MenuItem>
                    <MenuItem value={"Rail"}>Rail</MenuItem>
                    <MenuItem value={"Road"}>Road</MenuItem>
                  </Select>
                </FormControl>
              </Box>
            </Grid>
            <Grid item xs={12} md={4} py={2} px={4}>
              <Typography variant="h6">Kiometers covered</Typography>
              <Box mt={2}>
                <FormControl fullWidth>
                  <TextField
                    label="Number of kms"
                    variant="outlined"
                    value={distance}
                    onChange={(event) => {
                      setDistance(event.target.value);
                    }}
                  />
                </FormControl>
              </Box>
            </Grid>
            <Grid item xs={12} md={4} py={2} px={4}>
              <Typography variant="h6">Load</Typography>
              <Box mt={2}>
                <FormControl fullWidth>
                  <TextField
                    label="in kgs"
                    variant="outlined"
                    value={load}
                    onChange={(event) => {
                      setLoad(event.target.value);
                    }}
                  />
                </FormControl>
              </Box>
            </Grid>

            <Grid
              item
              xs={6}
              md={3}
              mt={2}
              mx="auto"
              alignItems="end"
              justifyContent="end"
            >
              <Button
                fullWidth
                variant="contained"
                onClick={handleAddEntry}
                color="primary"
                endIcon={<AddCircle />}
              >
                ADD MORE
              </Button>
            </Grid>
          </Grid>
        </Card>
      </Grid>

      {totalTransportEmission === null ? (
        <Typography></Typography>
      ) : (
        <Box>
          {totalTransportEmission.map((entry, index) => (
            <Card sx={{ my: 4 }} key={index} elevation={4} boxShadow={6}>
              <Box my={2} p={2} display="flex" flexDirection="row">
                <Grid my="auto" mx="1rem" container>
                  <Grid item xs={12} md={2}>
                    <Typography variant="h6">
                      Mode:
                      {entry.mode}
                    </Typography>
                  </Grid>
                  <Grid item xs={12} md={3}>
                    <Typography variant="h6">
                      Distance:{entry.distance} kms
                    </Typography>
                  </Grid>
                  <Grid item xs={12} md={4}>
                    <Typography variant="h6">
                      Emission:{entry.emission.toFixed(3)} kgCo2eq
                    </Typography>
                  </Grid>

                  <Grid item xs={6} mx="auto" md={3}>
                    <Button
                      variant="outlined"
                      onClick={() => handleDeleteEntry(index)}
                      color="error"
                      endIcon={<DeleteIcon />}
                    >
                      DELETE
                    </Button>
                  </Grid>
                </Grid>
              </Box>
            </Card>
          ))}
        </Box>
      )}

      {totalEmission !== 0 && (
        <Box mb="3rem">
          <div>Total Emission: {totalEmission.toFixed(3)} kg CO2 eq</div>
        </Box>
      )}

      <Grid
        item
        flex
        xs={11}
        mx="auto"
        mb={8}
        px={4}
        sx={{ display: { xs: "block", sm: "block", md: "none", lg: "none" } }}
      >
        <Box mx="auto">
          <Button
            variant="outlined"
            onClick={handleBack}
            startIcon={<West />}
            sx={{ mt: 1, ml: 1, width: "6rem" }}
          >
            Back
          </Button>
          <Button
            variant="contained"
            onClick={handleNext}
            endIcon={<East />}
            sx={{ mt: 1, ml: 2, width: "6rem" }}
          >
            Next
          </Button>
        </Box>
      </Grid>

      {/* 
         

        <Grid container fullWidth justifyContent="center" mx="auto" my="10%" borderRadius={4} p={3} xs={12}
        style={{     
            boxShadow: "rgba(0, 0, 0, 0.15) 0px 5px 15px 0px",
            background:"linear-gradient(to right bottom, #ffffff, #fdfdfe, #fafbfd, #f7f9fb, #f3f7fa"     
        }}>
            <Grid item xs={12} flex>
                <Typography mb={3} variant='h4'>
                    Transportation
                </Typography>
            </Grid>
        
            <Card elevation={2} sx={{ px:4, py:2, borderRadius:6}}>
                <Grid container xs={12} flex fullWidth>
                    <Grid item xs={12} md={6} py={2} px={4}>
                        <Typography variant='h6'>
                            Select type
                        </Typography>
                        <Box mt={2}>
                            <FormControl fullWidth>
                                <InputLabel id="demo-simple-select-label">Transporation type</InputLabel>
                                <Select
                                labelId="demo-simple-select-label"
                                value={transportType}
                                label="Transporation type"
                                onChange={(e) => {
                                    setTransportType(e.target.value);
                                }}
                                >
                                <MenuItem value={"Cold"}>Cold transportation</MenuItem>
                                <MenuItem value={"Traditional"}>Traditional transporation</MenuItem>
                                </Select>
                            </FormControl>
                        </Box>
                    </Grid>
                    <Grid item xs={12} md={6} py={2} px={4}>
                        <Typography variant='h6'>
                            Electricity used while transporation
                        </Typography>
                        <Box mt={2}>
                            <FormControl fullWidth>
                                    <TextField 
                                        label="in kWh" 
                                        variant="outlined"
                                        value={transportElectricity}
                                        onChange={(event) =>{setTransportElectricity(event.target.value)}} />
                            </FormControl>
                        </Box>
                    </Grid>
                    <Grid item xs={12} md={4} py={2} px={4}>
                        <Typography variant='h6'>
                            Select mode
                        </Typography>
                        <Box mt={2}>
                            <FormControl fullWidth>
                                <InputLabel id="demo-simple-select-label">Transporation by</InputLabel>
                                <Select
                                labelId="demo-simple-select-label"
                                value={transportMode}
                                label="Transporation by"
                                onChange={(e) => {
                                    setTransportMode(e.target.value);
                                }}
                                >
                                <MenuItem value={"Air"}>Air</MenuItem>
                                <MenuItem value={"Road"}>Road</MenuItem>
                                <MenuItem value={"Rail"}>Rail</MenuItem>
                                </Select>
                            </FormControl>
                        </Box>
                    </Grid>
                    <Grid item xs={12} md={4} py={2} px={4}>
                        <Typography variant='h6'>
                            Kiometers covered
                        </Typography>
                        <Box mt={2}>
                            <FormControl fullWidth>
                                    <TextField label="Number of kms" 
                                    variant="outlined"
                                    value={distance}
                                    onChange={(event) =>{setDistance(event.target.value)}}/>
                            </FormControl>
                        </Box>
                    </Grid>
                    <Grid item xs={12} md={4} py={2} px={4}>
                        <Typography variant='h6'>
                            Load 
                        </Typography>
                        <Box mt={2}>
                            <FormControl fullWidth>
                                    <TextField 
                                        label="in kgs" 
                                        variant="outlined" 
                                        value={loadPerVehicle}
                                        onChange={(event) =>{setLoadPerVehicle(event.target.value)}}/>
                            </FormControl>
                        </Box>
                    </Grid>   
                </Grid>
            </Card>

        </Grid>
        */}
    </>
  );
};

export default TransportSection;
